import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UpgradeState {
    currentPlan: string;
    planType: string;
    billingMethod: string;
    upgradeRequest: boolean;
    isUpgraded: boolean;
    planExpiresInSeconds: number;
}

const initialState: UpgradeState = {
    currentPlan: '',
    planType: '',
    billingMethod: '',
    upgradeRequest: false,
    isUpgraded: false,
    planExpiresInSeconds: 0
};

const upgradeSlice = createSlice({
    name: 'upgrade',
    initialState,
    reducers: {
        setCurrentPlan: (state, action: PayloadAction<string>) => {
            state.currentPlan = action.payload;
        },
        setPlanType: (state, action: PayloadAction<string>) => {
            state.planType = action.payload;
        },
        setBillingMethod: (state, action: PayloadAction<string>) => {
            state.billingMethod = action.payload;
        },
        setUpgradeRequest: (state, action: PayloadAction<boolean>) => {
            state.upgradeRequest = action.payload;
        },
        setIsUpgraded: (state, action: PayloadAction<boolean>) => {
            state.isUpgraded = action.payload;
        },
        setPlanExpiresInSeconds: (state, action: PayloadAction<number>) => {
            state.planExpiresInSeconds = action.payload;
        }

    }
})
export const
    {
        setCurrentPlan,
        setPlanType,
        setBillingMethod,
        setUpgradeRequest,
        setIsUpgraded,
        setPlanExpiresInSeconds
    } = upgradeSlice.actions

export default upgradeSlice.reducer;
